import { useModalContext } from '../../../CustomModal/ModalProvider.jsx';
import { useState } from 'react';
import { projectService } from '../../../../services/projectService.js';

export const useEnviarFile = () => {
  const [uploading, setUploading] = useState({});
  const [uploadProgresses, setUploadProgresses] = useState({});
  const [uploadSuccess, setUploadSuccess] = useState({});
  const { showSuccess, showError } = useModalContext();

  /**
   * @param {object|null} fileData - payload de um arquivo (com arquivo_fisico base64)
   * @param {string|null} fieldKey - chave em file_states
   * @param {object} fileStates - mapa completo (fallback se fileData/fieldKey ausentes)
   */
  const enviarFile = async (fileData, fieldKey, fileStates = {}) => {
    let docs = {};

    if (fileData?.arquivo_fisico && fieldKey) {
      docs = { [fieldKey]: fileData };
    } else if (fileStates && typeof fileStates === 'object') {
      docs = fileStates;
    }

    const entries = Object.entries(docs).filter(
      ([, data]) => data?.arquivo_fisico && typeof data.arquivo_fisico === 'string'
    );

    if (!entries.length) {
      console.error('❌ Nenhum arquivo válido para enviar', { fileData, fieldKey, fileStates });
      showError('Erro!', 'Nenhum arquivo válido para enviar. Selecione o PDF novamente.');
      throw new Error('Nenhum arquivo válido para enviar');
    }

    try {
      for (const [key, data] of entries) {
        await envia_arquivo_pythondoc(data, key);
      }
      showSuccess('Sucesso!', 'Documento enviado com sucesso!');
    } catch (error) {
      const apiMsg =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        error?.message;
      showError('Erro!', apiMsg || 'Falha ao enviar documento');
      throw error;
    }
  };

  const envia_arquivo_pythondoc = async (fileData, fieldName) => {
    const token = sessionStorage.getItem('Authorization');

    try {
      setUploading((prev) => ({ ...prev, [fieldName]: true }));

      const doc = { [fieldName]: fileData };

      await projectService.sendFilesUpload(doc, token, (progressEvent) => {
        if (!progressEvent.total) return;
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        setUploadProgresses((prev) => ({
          ...prev,
          [fieldName]: progress,
        }));
      });

      setUploadSuccess((prev) => ({ ...prev, [fieldName]: true }));
    } finally {
      setUploading((prev) => ({ ...prev, [fieldName]: false }));
    }
  };

  return {
    enviarFile,
    uploading,
    uploadProgresses,
    uploadSuccess,
  };
};
